import { makeFloat, useCurrency, useGetFullBalance } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';

export const Content = () => {
  const { t } = useTranslation();
  const { bonusAccountCasino } = useGetFullBalance();
  const { currencyIcon } = useCurrency();

  return (
    <div className="flex flex-col gap-4 py-6 px-4 412:px-7">
      <p className="text-bm_title text-xl font-bold uppercase text-center">
        {t('bonusModal.areYouSure')}
      </p>
      <div className="flex flex-col w-full text-center gap-2 text-bm_text">
        <p className="text-base leading-5">{t('bonusModal.whenYouChange')}</p>
        <p className="text-2xl leading-5">
          {currencyIcon + makeFloat(bonusAccountCasino?.balance)}
        </p>
      </div>
    </div>
  );
};
